import React from "react";
import { Card, CardHeader, CardBody, CardFooter, CardTitle } from "reactstrap";
import { AvForm } from "availity-reactstrap-validation";
import ButtonLoader from "../../components/ButtonLoader/ButtonLoader";
import FormRow from "../../components/Row/FormRow";
import SelectRow from "../../components/Select/SelectRow";
import strings from "../../core/translate";

const CustomerVehicleForm = ({
  id,
  loading,
  selectedMake,
  makes,
  selectedModel,
  models,
  trimId,
  trims,
  plateCode,
  plateCodeOptions,
  energy,
  energyOptions,
  year,
  plateNumber,
  vin,
  username,
  handleValidSubmit,
  handleMakeSelect,
  handleModelSelect,
  handleTrimSelect,
  handleTextChange,
  handleInputChange,
  CardStyle,
}) => {
  return (
    <AvForm
      onValidSubmit={handleValidSubmit}
      className="form-horizontal"
      id="TypeValidation"
    >
      <Card style={CardStyle}>
        <CardHeader>
          <CardTitle tag="h4">{strings.information}</CardTitle>
        </CardHeader>
        <CardBody>
          {!id && (
            <SelectRow
              required={true}
              label={strings.make}
              name="makeId"
              defaultValue={selectedMake}
              data={makes}
              changeInput={(e) => handleMakeSelect(e)}
            />
          )}
          {!id && (
            <SelectRow
              required={true}
              label={strings.model}
              name="modelId"
              defaultValue={selectedModel}
              data={models}
              changeInput={(e) => handleModelSelect(e)}
            />
          )}
          {!id && (
            <SelectRow
              label={strings.trim}
              name="trimId"
              defaultValue={trimId}
              data={trims}
              changeInput={(e) => handleTrimSelect(e)}
            />
          )}
          <SelectRow
            required={true}
            label={strings.platecode}
            placeholder={strings.select}
            name="plateCode"
            defaultValue={plateCode}
            data={plateCodeOptions}
            changeInput={(selectedOption) =>
              handleInputChange(selectedOption, "plateCode")
            }
          />

          <SelectRow
            required={false}
            label={strings.energytype}
            placeholder={strings.select}
            name="energy"
            defaultValue={energy}
            data={energyOptions}
            changeInput={(selectedOption) =>
              handleInputChange(selectedOption, "energy")
            }
          />

          <FormRow
            label={strings.platenumber}
            name="plateNumber"
            data={plateNumber}
            changeInput={handleTextChange}
          />
          <FormRow
            label={strings.vin}
            name="vin"
            data={vin}
            required={false}
            changeInput={handleTextChange}
            maxLength={17}
            minLength={17}
          />
          <FormRow
            label={strings.username}
            name="username"
            data={username}
            required={false}
            changeInput={handleTextChange}
          />
          {!id && (
            <FormRow
              label={strings.year}
              name="year"
              data={year}
              changeInput={handleTextChange}
              type="number"
            />
          )}
        </CardBody>
        <CardFooter className="text-center">
          <ButtonLoader color="primary" loading={loading}>
            {strings.save}
          </ButtonLoader>
        </CardFooter>
      </Card>
    </AvForm>
  );
};

export default CustomerVehicleForm;
